export const ADHESION_CREATE_RESET = "ADHESION_CREATE_RESET";
export const ADHESION_CREATE_SET_CREATED = "ADHESION_CREATE_SET_CREATED";
export const ADHESION_CREATE_SET_ERROR = "ADHESION_CREATE_SET_ERROR";
export const ADHESION_CREATE_SET_VIOLATIONS = "ADHESION_CREATE_SET_VIOLATIONS";
export const ADHESION_CREATE_TOGGLE_LOADING = "ADHESION_CREATE_TOGGLE_LOADING";
